import React from 'react';
import { CmsBrowsePage } from 'js/model/cms/cms-browse-page';
import styles from './NoResults.module.css';

interface Props {
  cms: CmsBrowsePage['page']['browse']['no-results'];
}

export class NoResults extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <div className={styles.noResults}>
        <div className={styles.icon} />

        <div className={styles.heading}>{this.props.cms.heading}</div>

        <div>{this.props.cms.hint}</div>
      </div>
    );
  }
}
